// extracted by mini-css-extract-plugin
export default {"content":"WaitConfirm_content__szZQU","header":"WaitConfirm_header__3K80G","title":"WaitConfirm_title__KUaVo"};